/**
 * Cart Drawer Mobile Fix
 * This script adds additional debugging and fixes for mobile cart drawer functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Drawer Mobile Fix initialized');

  // Function to add mobile-specific fixes
  function addMobileCartFixes() {
    // Check if we're on mobile
    const isMobile = window.innerWidth < 990;
    console.log(`Device detected as: ${isMobile ? 'mobile' : 'desktop'}`);

    if (!isMobile) return;

    // Get the cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found - cannot apply mobile fixes');
      return;
    }

    // Get the cart-drawer-items element
    const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
    if (!cartDrawerItems) {
      console.error('cart-drawer-items element not found - cannot apply mobile fixes');
      return;
    }

    console.log('Adding mobile-specific fixes to cart drawer');

    // Find all remove buttons in the cart drawer
    const removeButtons = cartDrawerItems.querySelectorAll('cart-remove-button');
    console.log(`Found ${removeButtons.length} remove buttons in mobile cart drawer`);

    // Enhance remove buttons for mobile
    removeButtons.forEach((button, index) => {
      // Make sure the button is visible and clickable
      button.style.position = 'relative';
      button.style.zIndex = '100000';
      button.style.pointerEvents = 'auto';

      // Add a debug click handler
      button.addEventListener('click', function(event) {
        console.log(`Mobile cart: Remove button ${index + 1} clicked`);
      });
    });

    // Find all quantity inputs in the cart drawer
    const quantityInputs = cartDrawerItems.querySelectorAll('.quantity__input');
    console.log(`Found ${quantityInputs.length} quantity inputs in mobile cart drawer`);

    // Find all plus/minus buttons in the cart drawer
    const plusButtons = cartDrawerItems.querySelectorAll('[name="plus"]');
    const minusButtons = cartDrawerItems.querySelectorAll('[name="minus"]');
    console.log(`Found ${plusButtons.length} plus buttons and ${minusButtons.length} minus buttons in mobile cart drawer`);

    // Enhance plus/minus buttons for mobile
    [...plusButtons, ...minusButtons].forEach((button, index) => {
      // Make sure the button is visible and clickable
      button.style.position = 'relative';
      button.style.zIndex = '100000';
      button.style.pointerEvents = 'auto';

      // Add a debug click handler
      button.addEventListener('click', function(event) {
        console.log(`Mobile cart: ${button.getAttribute('name')} button ${index + 1} clicked`);
      });
    });
  }

  // Apply mobile fixes when cart drawer is opened (excluding mobile cart icon which now links to cart page)
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a cart button (excluding mobile cart icon)
    if (event.target.closest('[data-cart-drawer-trigger], .js-drawer-open-cart, #cart-icon-bubble')) {
      // Wait for the cart drawer to open
      setTimeout(addMobileCartFixes, 500);
    }
  });

  // Also apply mobile fixes on page load in case cart drawer is already open
  setTimeout(addMobileCartFixes, 1000);

  // Add a mutation observer to detect when the cart drawer becomes active
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            console.log('Cart drawer became active, applying mobile fixes');
            setTimeout(addMobileCartFixes, 300);
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }

  // Add window resize listener to reapply fixes when switching between mobile and desktop
  window.addEventListener('resize', function() {
    if (cartDrawer && cartDrawer.classList.contains('active')) {
      setTimeout(addMobileCartFixes, 300);
    }
  });
});
